import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";

const IncidentReportForm = ({
  formData,
  handleChange,
  handleNestedChange,
  addNestedField,
  removeNestedField,
  isLoading,
}) => {
  const incidentOptions = [
    "Injury to client, staff, or visitor",
    "Seizure",
    "Client act of violence (self/others)",
    "Equipment failure",
    "Damage/destruction of property",
    "Client abuse or neglect",
    "Medication error",
    "Suicide or attempted suicide",
    "Exposure to communicable disease",
    "Client(s) leaving program without permission",
    "Violation of infection control policies",
    "Vehicular accident",
    "Violence or aggression",
    "Hold-up",
    "Use/possession of weapon(s)",
    "Theft - medication/missing medication",
    "Infection",
    "Falls",
    "Theft – property",
    "Harassment",
  ];

  return (
    <div className="p-4">
      <div className="col-12 mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
          Incident Report Form
        </small>
      </div>

      {/* ========== BASIC INFO ========== */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className="form-control"
              name="reportCompletedBy"
              value={formData.reportCompletedBy}
              onChange={handleChange}
              placeholder="Report Completed By"
            />
            <label>Report Completed By *</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="date"
              className="form-control"
              name="dateOfReport"
              value={formData.dateOfReport}
              onChange={handleChange}
            />
            <label>Date of Report *</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="datetime-local"
              className="form-control"
              name="incidentDateTime"
              value={formData.incidentDateTime}
              onChange={handleChange}
            />
            <label>Date & Time of Incident *</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline">
            <input
              type="text"
              className="form-control"
              name="placeOfIncident"
              value={formData.placeOfIncident}
              onChange={handleChange}
              placeholder="Place of Incident"
            />
            <label>Place of Incident *</label>
          </div>
        </div>
      </div>

      {/* ========== CLIENTS & STAFF ========== */}
      <div className="row g-3 mb-4">
        {/* Clients */}
        <div className="col-md-6">
          <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
            Clients Involved *
          </small>
          {formData.clients.map((c, i) => (
            <div key={i} className="row align-items-center mb-2 g-2 border rounded-3 p-3 bg-light-subtle">
              <div className="col-md-1 text-center">{i + 1}</div>
              <div className="col-md-10">
                <div className="form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control"
                    value={c.name}
                    onChange={(e) => handleNestedChange("clients", i, e.target.value)}
                    placeholder="Name"
                  />
                  <label>Name</label>
                </div>
              </div>
              <div className="col-md-1">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-md w-100"
                  onClick={() => removeNestedField("clients", i)}
                  disabled={formData.clients.length === 1}
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-outline-primary btn-sm mt-2 w-100"
            onClick={() => addNestedField("clients")}
          >
            <i className="ri-add-line"></i> Add Client
          </button>
        </div>

        {/* Staff */}
        <div className="col-md-6">
          <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
            Staff Members Involved *
          </small>
          {formData.staff.map((s, i) => (
            <div key={i} className="row align-items-center mb-2 g-2 border rounded-3 p-3 bg-light-subtle">
              <div className="col-md-1 text-center">{i + 1}</div>
              <div className="col-md-10">
                <div className="form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control"
                    value={s.name}
                    onChange={(e) => handleNestedChange("staff", i, e.target.value)}
                    placeholder="Name"
                  />
                  <label>Name</label>
                </div>
              </div>
              <div className="col-md-1">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-md w-100"
                  onClick={() => removeNestedField("staff", i)}
                  disabled={formData.staff.length === 1}
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-outline-primary btn-sm mt-2 w-100"
            onClick={() => addNestedField("staff")}
          >
            <i className="ri-add-line"></i> Add Staff
          </button>
        </div>
      </div>

      {/* ========== NATURE OF INCIDENT ========== */}
      <div className="col-md-12 mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
          Nature of Incident *
        </small>
        <div className="row g-3">
          {incidentOptions.map((opt, index) => (
            <div className="col-md-4" key={index}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="natureOfIncident"
                  value={opt}
                  checked={formData.natureOfIncident === opt}
                  onChange={handleChange}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            </div>
          ))}
          <div className="col-md-4">
            <div className="form-check d-flex align-items-center">
              <input
                className="form-check-input me-2"
                type="radio"
                name="natureOfIncident"
                value="Other"
                checked={formData.natureOfIncident === "Other"}
                onChange={handleChange}
              />
              <label className="form-check-label me-2">Other:</label>
              {formData.natureOfIncident === "Other" && (
                <input
                  type="text"
                  className="form-control"
                  name="otherNature"
                  value={formData.otherNature}
                  onChange={handleChange}
                  placeholder="Specify..."
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ========== TEXTAREAS ========== */}
      {[
        { label: "Summary of Events *", name: "summary" },
        { label: "Action Taken by Staff *", name: "actionTaken" },
        { label: "Other Witnesses (If applicable)", name: "otherWitnesses" },
        { label: "Debriefing Details *", name: "debriefingDetails" },
        { label: "Other Comments", name: "otherComments" },
      ].map((f, i) => (
        <div className="col-md-12 mb-4" key={i}>
          <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
            {f.label}
          </small>
          <textarea
            className="form-control"
            rows="3"
            name={f.name}
            value={formData[f.name]}
            onChange={handleChange}
          ></textarea>
        </div>
      ))}

      {/* Director Notification */}
      <div className="col-md-12 mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
          Director Information
        </small>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline">
              <input
                type="datetime-local"
                className="form-control"
                name="directorDateTime"
                value={formData.directorDateTime}
                onChange={handleChange}
              />
              <label>Director Notified (Date & Time) *</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline">
              <input
                type="text"
                className="form-control"
                name="director_name"
                value={formData.director_name}
                onChange={handleChange}
              />
              <label>Director Name</label>
            </div>
          </div>
        </div>
      </div>



      {/* Signatures */}
      <div className="col-md-12 mb-4">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
          Signatures of All Staff Involved *
        </small>
        {formData.signatures.map((s, i) => (
          <div key={i} className="row align-items-center mb-2 g-2 border rounded-3 p-2 bg-light-subtle">
            <div className="col-md-1 text-center">{i + 1}</div>
            <div className="col-md-9">
              <div className="form-floating form-floating-outline">
                <input
                  type="text"
                  className="form-control"
                  value={s.name}
                  onChange={(e) => handleNestedChange("signatures", i, e.target.value)}
                  placeholder="Name"
                />
                <label>Name</label>
              </div>
            </div>
            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-outline-danger btn-lg w-100"
                onClick={() => removeNestedField("signatures", i)}
                disabled={formData.signatures.length === 1}
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="btn btn-outline-primary btn-sm mt-2 w-100"
          onClick={() => addNestedField("signatures")}
        >
          <i className="ri-add-line"></i> Add Signature
        </button>
      </div>

      {/* ========== FOLLOW-UP & TRUSTEES ========== */}
      <div className="row mb-4">
        <div className="col-md-6">
          <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
            Follow-Up Required *
          </small>
          <div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="followUpNecessary"
                value="Yes"
                checked={formData.followUpNecessary === "Yes"}
                onChange={handleChange}
              />
              <label className="form-check-label">Yes</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="followUpNecessary"
                value="No"
                checked={formData.followUpNecessary === "No"}
                onChange={handleChange}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>
          {formData.followUpNecessary === "Yes" && (
            <textarea
              className="form-control mt-2"
              rows="3"
              name="followUpNecessaryDetails"
              value={formData.followUpNecessaryDetails}
              onChange={handleChange}
              placeholder="Details of Follow-Up Action..."
            ></textarea>
          )}
        </div>

        <div className="col-md-6">
          <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
            Action Reported to Trustees *
          </small>
          <div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="actionReportedToTrustees"
                value="Yes"
                checked={formData.actionReportedToTrustees === "Yes"}
                onChange={handleChange}
              />
              <label className="form-check-label">Yes</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="actionReportedToTrustees"
                value="No"
                checked={formData.actionReportedToTrustees === "No"}
                onChange={handleChange}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>
          {formData.actionReportedToTrustees === "Yes" && (
            <div className="mt-2">
              <div className="form-floating form-floating-outline mb-2">
                <input
                  type="date"
                  className="form-control"
                  name="trusteesDate"
                  value={formData.trusteesDate}
                  onChange={handleChange}
                />
                <label>Specify When</label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default IncidentReportForm;